<template>
  <div class="loyalty text-neutral-800">
    <div class="max-w-946 pt-10 md:pb-10">
      <LoyaltyReferralLinkSharer
        :country="country"
        :link="isAuthenticated ? getReferralLink(spaazaUser.referralCode, user.firstName) : null"
        @signup="$router.push($i18n.localePath({ name: 'signup' }))"
        @click="shareLink({
          medium: $event.medium.Icon,
          link: getReferralLink(spaazaUser.referralCode, user.firstName),
          code: spaazaUser.referralCode,
          userId: (isAuthenticated && user) ? user.user._id : undefined
        })"
      />
    </div>
    <div class="pt-10 max-w-858 md:pb-10">
      <div class="px-4 md:text-center">
        <p class="o-heading-2 mb-1" v-text="$t('Loyalty.LoyaltyProgram.NewLoyaltyPage.WhatAreYouSavingFor')" />
        <!-- <p class="o-body" v-text="$t('Loyalty.LoyaltyProgram.NewLoyaltyPage.SaveForExclusiveItems')" /> -->
        <p class="o-body mt-6" v-text="$t('Loyalty.LoyaltyProgram.NewLoyaltyPage.SaveForExclusiveItemsDescription')" />
      </div>
      <WebshopProductSlider class="mt-6" :products="products" />
    </div>
    <LoyaltyBenefits :country="country" :locale="locale" class="mt-6 mb-10" />
    <div class="mt-6 px-4 max-w-858 pb-10">
      <ViewWebshopBlock />
    </div>
  </div>
</template>

<script>
import { GET_SPAAZA_USER } from '@/utils/store/actionTypes'
import { IS_AUTHENTICATED } from '@/utils/store/getterTypes'
import { getImagePaths, getEuros } from '@/utils/general'
import { mapState, mapActions, mapGetters } from 'vuex'
import linkSharerMixin from '@/mixins/linksharer'
import { WomenCountries } from '@/enums/general'
import ViewWebshopBlock from '@/components/ViewWebshopBlock'
import LoyaltyReferralLinkSharer from '@/components/LoyaltyReferralLinkSharer'
import WebshopProductSlider from '@/components/WebshopProductSlider'
import LoyaltyBenefits from '@/components/LoyaltyBenefits'

export default {
  name: 'ReferAFriend',
  layout: 'homepage',
  components: { ViewWebshopBlock, LoyaltyBenefits, LoyaltyReferralLinkSharer, WebshopProductSlider },
  mixins: [linkSharerMixin],
  async fetch () {
    try {
      if (!this.spaazaUser.referralCode) {
        await this.getSpaazaUser()
      }
    } catch (error) {
      this.$ota.general.logError(error)
    }
  },
  computed: {
    isWomenCountry () {
      return WomenCountries.includes(this.country)
    },
    usps () {
      const path = 'Loyalty.LoyaltyProgram.NewLoyaltyPage.USPS'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, i) => this.$t(`${path}[${i}]`, { ...this.variables }))
    },
    products () {
      const path = 'Loyalty.LoyaltyProgram.NewLoyaltyPage.MenProducts'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      const products = items.map((_, i) => ({
        image: getImagePaths({
          path: this.$t(`${path}[${i}].Url`),
          s3: true
        }),
        title: this.$t(`${path}[${i}].Title`, { ...this.variables }),
        description: this.$t(`${path}[${i}].Description`, { ...this.variables })
      }))

      if (this.isWomenCountry) {
        return [products[0], this.womenProducts[0], products[2], this.womenProducts[1]]
      }

      return products
    },
    womenProducts () {
      const path = 'Loyalty.LoyaltyProgram.NewLoyaltyPage.WomenProducts'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, i) => ({
        image: getImagePaths({
          path: this.$t(`${path}[${i}].Url`),
          s3: true
        }),
        title: this.$t(`${path}[${i}].Title`, { ...this.variables }),
        description: this.$t(`${path}[${i}].Description`, { ...this.variables })
      }))
    },
    variables () {
      return {
        loyaltyAmount: getEuros(this.country, 10)
      }
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapState('spaaza', {
      spaazaUser: state => state
    }),
    ...mapState('auth', {
      user: state => state.user
    }),
    ...mapGetters('auth', {
      isAuthenticated: IS_AUTHENTICATED
    })
  },
  methods: {
    ...mapActions('spaaza', {
      getSpaazaUser: GET_SPAAZA_USER
    })
  }
}
</script>

<style lang="postcss" scoped>
.loyalty {
  .dont-worry-usps {
    @apply bg-transparent p-0 text-neutral-800 !important;
  }

  .max-w-1200 {
    @apply mx-auto;
    max-width: 119.2rem;
  }

  .max-w-946 {
    @apply mx-auto;
    max-width: 94.6rem;
  }

  h1 {
    line-height: normal;
  }

  >>> .max-w-51rem {
    max-width: unset;
  }

  .max-w-858 {
    @apply mx-auto;
    max-width: 85.8rem;
  }
}
</style>
